import React from 'react';
import Card from '../../ui/Card';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
const OrderBookTracker: React.FC = () => {
  const data = [{
    category: 'Q1 FY24',
    orderBook: 2450,
    shipment: 2380,
    deviation: -2.9
  }, {
    category: 'Q2 FY24',
    orderBook: 2580,
    shipment: 2620,
    deviation: 1.6
  }, {
    category: 'Q3 FY24',
    orderBook: 2720,
    shipment: 2650,
    deviation: -2.6
  }, {
    category: 'Q4 FY24',
    orderBook: 2850,
    shipment: 2900,
    deviation: 1.8
  }];
  return <Card className="p-6" data-id="element-8700">
      <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-8701">
        Order Book vs Shipment
      </h3>
      <div className="space-y-3" data-id="element-8702">
        {data.map((item, index) => <div key={index} className="pb-3 border-b border-gray-100 last:border-0" data-id="element-8703">
            <div className="flex items-center justify-between mb-1" data-id="element-8704">
              <span className="text-sm font-medium text-gray-700" data-id="element-8705">
                {item.category}
              </span>
              <div className="flex items-center" data-id="element-8706">
                {item.deviation < 0 ? <TrendingDownIcon size={14} className="text-red-500 mr-1" data-id="element-8707" /> : <TrendingUpIcon size={14} className="text-green-500 mr-1" data-id="element-8708" />}
                <span className={`text-sm font-semibold ${item.deviation < 0 ? 'text-red-600' : 'text-green-600'}`} data-id="element-8709">
                  {item.deviation > 0 ? '+' : ''}
                  {item.deviation}%
                </span>
              </div>
            </div>
            <div className="flex items-center justify-between text-xs text-gray-600" data-id="element-8710">
              <span data-id="element-8711">Order: ₹{item.orderBook} Cr</span>
              <span data-id="element-8712">Shipped: ₹{item.shipment} Cr</span>
            </div>
          </div>)}
      </div>
    </Card>;
};
export default OrderBookTracker;